import { useState } from "react";
import { BookOpen, Megaphone, MessageCircleQuestion, Sprout } from "lucide-react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const STEPS = [
  { icon: Sprout, title: "Welcome to the club", body: "This is your marketing kitchen: tried-and-tested templates, honest answers, templates and seasonal ideas, all built on the Roots Method for independent food, drink and hospitality founders. Here's the 30-second tour." },
  { icon: BookOpen, title: "Your Guide Book", body: "Templates, videos, seasonal packs and step-by-step guides (the basics, social media, loyalty and partnerships) you can use the same day. Heart your favourites to keep them on your dashboard.", to: "/app/guides" },
  { icon: MessageCircleQuestion, title: "Ask Lindsay", body: "Stuck on a marketing question? Ask in plain English. You'll get an answer in Lindsay's voice from her knowledge bank, and anything tricky goes straight to her. Base includes a monthly question allowance, and Pro is unlimited.", to: "/app/ask" },
  { icon: Megaphone, title: "Seasonal ideas & drops", body: "Timely ideas for your side of the trade, plus Lindsay's videos and written pieces as she publishes them.", to: "/app/drops" },
];

export const WelcomeTour = ({ open, onClose }) => {
  const { user, setUser } = useAuth();
  const [i, setI] = useState(0);
  const finish = () => {
    if (!user?.tour_seen) {
      api.post("/me/tour-seen").catch(() => {});
      setUser({ ...user, tour_seen: true });
    }
    setI(0);
    onClose();
  };
  const s = STEPS[i];
  const last = i === STEPS.length - 1;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && finish()}>
      <DialogContent aria-describedby={undefined} className="max-w-md bg-card border-border p-8" data-testid="welcome-tour">
        <div className="flex gap-1.5 mb-6">{STEPS.map((_, k) => <span key={k} className={`h-1.5 flex-1 rounded-full transition-colors ${k <= i ? "bg-pinkb" : "bg-secondary"}`} />)}</div>
        <s.icon className="h-8 w-8 text-pinkb" />
        <div className="eyebrow mt-4">Step {i + 1} of {STEPS.length}</div>
        <DialogTitle className="font-serif text-2xl text-navy mt-1" data-testid="welcome-tour-title">{s.title}</DialogTitle>
        <p className="text-sm text-muted-foreground mt-2">{s.body}</p>
        {s.to && <Link to={s.to} onClick={finish} data-testid="welcome-tour-try" className="text-sm text-pinkb hover:underline mt-3 inline-block">Take me there now →</Link>}
        <div className="mt-8 flex items-center justify-between">
          <button onClick={finish} data-testid="welcome-tour-skip" className="text-xs text-muted-foreground hover:text-foreground">Skip tour</button>
          <div className="flex gap-2">
            {i > 0 && <button onClick={() => setI(i - 1)} data-testid="welcome-tour-back" className="rounded-full border border-border px-4 py-2 text-sm hover:border-pinkb transition-colors">Back</button>}
            <button onClick={() => (last ? finish() : setI(i + 1))} data-testid="welcome-tour-next" className="rounded-full bg-navy hover:bg-navy/90 text-white px-5 py-2 text-sm transition-colors">{last ? "Let's go" : "Next"}</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
